// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.t0PHFI{display:flex;flex-direction:column;justify-content:center;align-items:center}.desktop .t0PHFI{height:617px}.mobile .t0PHFI{height:341px}.desktop .Mst9e2{width:63px}.mobile .Mst9e2{width:48px}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorWrapper": `t0PHFI`,
	"errorIcon": `Mst9e2`
};
export default ___CSS_LOADER_EXPORT___;
